// Exportacion a CSV pensada para Excel en español:
//   - UTF-8 CON BOM  -> los acentos no salen rotos.
//   - separador ';'  -> Excel en español no separa por comas.
// Las columnas son { etiqueta, valor:(fila)=>string|number }.
//
// El CSV se queda como segunda opcion, no como la principal: no declara
// tipos, asi que Excel adivina al abrirlo y adivina mal justo donde
// duele (el SKU 7501234567890 acaba en 7.50123E+12). Para lo que se
// manda a contabilidad esta el .xlsx; el CSV sigue aqui porque es lo que
// tragan los sistemas de terceros y las importaciones a otro software.
import { guardarArchivo } from './descarga';

const BOM = '﻿';

// Un CSV es texto que Excel INTERPRETA al abrirlo, y una celda que
// empieza por uno de estos caracteres se interpreta como formula. El
// nombre de un producto lo escribe el cliente, y ese archivo lo abre
// despues alguien de contabilidad: `=cmd|'/c ...'!A1` en un nombre es
// ejecucion de comandos en su maquina. El apostrofo delante fuerza a
// leerlo como texto — se ve en la celda, y es el precio de no ejecutar
// lo que otro escribio. (En el .xlsx no hace falta: alli el tipo va
// declarado y una cadena nunca se evalua.)
const PELIGROSOS = /^[=+\-@\t\r]/;

function celda(v) {
  if (v == null) return '';
  let s = String(v);
  if (PELIGROSOS.test(s)) s = `'${s}`;
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// `pie` es la Fase 3.2 de DIRECTRIZ-VENTAJA: un número no sale del
// sistema sin su definición al lado. Si este archivo llega a la bandeja
// de un proveedor, el método se queda en el repositorio y él recibe una
// nota sin saber contra qué se le midió.
export function exportarCSV(nombreArchivo, columnas, filas, pie) {
  const SEP = ';';
  const encabezado = columnas.map((c) => celda(c.etiqueta)).join(SEP);
  const cuerpo = filas
    .map((f) => columnas.map((c) => celda(c.valor(f))).join(SEP))
    .join('\r\n');
  const contenido = BOM + encabezado + '\r\n' + cuerpo
    + (pie ? `\r\n\r\n${celda(pie)}` : '');

  guardarArchivo(
    new Blob([contenido], { type: 'text/csv;charset=utf-8;' }),
    `${nombreArchivo}.csv`,
  );
}
